import posthog from "posthog-js";

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_HOST =
  process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com";

/** Set to "true" only on production (Render `my-mom-dad-fe`). Omit or "false" for local/QA. */
const POSTHOG_ENABLED =
  String(process.env.REACT_APP_POSTHOG_ENABLED || "").toLowerCase() === "true";

/** Paths we do not track (vendor/admin dashboards). */
const IGNORED_PATH_PREFIXES = [
  "/admin",
  "/vendor/dashboard",
  "/vendor/login",
];

export function isPostHogEnabled() {
  return POSTHOG_ENABLED && Boolean(POSTHOG_KEY?.trim());
}

export function shouldTrackPath(pathname = "") {
  const path = String(pathname || "");
  return !IGNORED_PATH_PREFIXES.some((prefix) => path.startsWith(prefix));
}

let initStarted = false;

export function initPostHog() {
  if (initStarted || typeof window === "undefined" || !isPostHogEnabled()) {
    return;
  }
  initStarted = true;

  posthog.init(POSTHOG_KEY.trim(), {
    api_host: POSTHOG_HOST,
    defaults: "2026-01-30",
    person_profiles: "always",
    // Avoid /flags calls (401 with some keys); analytics still uses /e/
    advanced_disable_flags: true,
    capture_pageview: false,
    capture_pageleave: true,
    autocapture: true,
    persistence: "localStorage+cookie",
    loaded: (ph) => {
      ph.register({ user_type: "guest" });
      if (process.env.NODE_ENV === "development") {
        ph.debug();
      }
    },
  });
}

export function captureEvent(eventName, properties = {}) {
  if (!isPostHogEnabled()) return;
  posthog.capture(eventName, properties);
}

export function trackPageView(pathname, search = "") {
  if (!isPostHogEnabled() || !shouldTrackPath(pathname)) return;
  const path = `${pathname}${search || ""}`;
  posthog.capture("$pageview", {
    $current_url: window.location.href,
    path: pathname,
  });
}

export function registerSuperProperties(properties = {}) {
  if (!isPostHogEnabled()) return;
  posthog.register(properties);
}

export function identifyCustomer(user) {
  if (!isPostHogEnabled() || !user) return;
  const id = user.id ?? user._id;
  if (!id) return;
  posthog.identify(String(id), {
    name: user.name,
    email: user.email,
    user_type: "customer",
  });
  posthog.register({ user_type: "customer" });
}

export function resetAnalytics() {
  if (!isPostHogEnabled()) return;
  posthog.reset();
  posthog.register({ user_type: "guest" });
}
